export default __webpack_public_path__ + "static/media/Horizontal_Banner_White_trans.a6bb6fcc.png";